import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  connect () {
    const form = this.element.closest('form')
    const skipValidation = this.data.get('skip-validation')
    if (form) {
      this.element.addEventListener('change', () => {
        if (skipValidation === 'skip' || form.reportValidity()) {
          Turbo.navigator.submitForm(form)
        }
      })
    } else {
      // console.log('auto-submit: no form found')
    }
  }
}
